import getLocalString from "constants/Localization";
import { useCreateDailyFormInspectionMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCreateDailyFormInspection() {
  const [mutation, { loading, data, error }] = useCreateDailyFormInspectionMutation({
    refetchQueries: ["getDailyFormInspections", "customGetDailyFormInspections"],
  });

  const [createDailyFormInspection, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createDailyFormInspection",
    },
    {
      successMessage: getLocalString("fleet.create-inspection-success"),
      failureMessage: getLocalString("fleet.create-inspection-failure"),
    }
  );

  return [createDailyFormInspection, context] as const;
}
